import {createSlice} from '@reduxjs/toolkit';

const loggedInUserSlice = createSlice({
    name: 'loggedInUser',
    initialState: {},
    reducers: {
        set: (state, action) => ({...action.payload}),
        remove: () => ({}),
    },
    selectors: {
        select: (state) => state,
    },
});

export const {set, remove} = loggedInUserSlice.actions;
export const {select} = loggedInUserSlice.selectors;
export const {reducer} = loggedInUserSlice;